import { useAdmin } from "../../../contexts/AdminContext";

export default function BekanntAus() {
  const { settings } = useAdmin();
  
  const mediaLogos = settings.partners.map(p => ({
    name: p,
    style: "font-serif font-bold tracking-widest text-slate-800 text-base lg:text-lg",
  }));

  if (mediaLogos.length === 0) return null;

  return (
    <section className="bg-slate-50 py-10 border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 lg:gap-16">
          {/* Label */}
          <p className="text-slate-400 text-xs font-semibold tracking-[0.2em] uppercase whitespace-nowrap shrink-0">
            Bekannt aus
          </p>

          {/* Divider vertical */}
          <div className="hidden md:block w-px h-8 bg-slate-200 shrink-0"></div>

          {/* Logos */}
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-10 lg:gap-14">
            {mediaLogos.map((logo) => (
              <div
                key={logo.name}
                className="opacity-60 hover:opacity-100 transition-opacity duration-300 cursor-default select-none"
              >
                <span className={logo.style}>{logo.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
